"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderApp = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_dom_1 = __importDefault(require("react-dom"));
const providers_1 = require("./providers");
const renderApp = ({ App, history, defaultHistory, store, initializedFeatures, externalComponents, domElement, }) => {
    react_dom_1.default.render((0, jsx_runtime_1.jsx)(providers_1.SubAppProviders, { history: history || defaultHistory, children: (0, jsx_runtime_1.jsx)(App, { oldData: { store, initializedFeatures, externalComponents, history: defaultHistory } }) }), domElement);
};
exports.renderApp = renderApp;
//# sourceMappingURL=renderApp.js.map